import { QTECode, QTEType } from '@common/constants';
import { CommonProductModel } from '@common/models';
import { Product } from '@common/utils/getProductDescription';

// the filter for hidden products can be any combination of attributes from the CommonProductModel
export interface ProductFilter extends Partial<CommonProductModel> {}

// these are some indificual predefined filters that get used in multiple places, so we should have a single source of truth
export const ProductFilters = {
    smallProjectFee: { qteTypeId: QTEType.Other, qteCodeId: QTECode.SmallProjectFee },
    smallProjectColor: { qteTypeId: QTEType.Material, qteCodeId: QTECode.SmallProjectFee },
    oversizeFeeForIslands: { qteTypeId: QTEType.Other, qteCodeId: QTECode.OversizeFee },
    insideDiagonal: { qteTypeId: QTEType.Diagonal, qteCodeId: QTECode.InsideCorner },
    outsideDiagonal: { qteTypeId: QTEType.Diagonal, qteCodeId: QTECode.OutsideCorner },
    customWork: { qteTypeId: QTEType.Other, qteCodeId: QTECode.CustomLabor },
    warranty: { qteTypeId: QTEType.Other, qteCodeId: QTECode.Warranty },
};

// this is a predefined set of filters for any products that should be hidden from the user
export const hiddenProducts: ProductFilter[] = [ProductFilters.smallProjectFee];

/**
 * Returns true if the product matches a single filter
 * @param filter a ProductFilter record
 * @param product the product to test
 */
export const doesProductMatchFilter = (filter: ProductFilter, product: Product) => {
    const keys = Object.keys(filter) as Array<keyof ProductFilter>;
    if (keys.length === 0) {
        return false;
    }
    return keys.every((key) => {
        return key in filter && key in product && filter[key] === product[key];
    });
};
/**
 * Returns true if the product matches any of the filters of the given filter list
 * @param filterList an array of ProductFilter records
 * @param product the product to test
 */
export const isProductInFilterList = (filterList: ProductFilter[], product: Product) => {
    return filterList.some((filter) => doesProductMatchFilter(filter, product));
};

/**
 * Returns true if the product matches any of the predefined hidden products and should be hidden
 * @param product the product to test
 */
export const isHiddenProduct = (product: Product) => isProductInFilterList(hiddenProducts, product);
